<template>
  <b-list-group-item class="contraction-item mb-1 small" :class="priority ? 'priority-' + priority : ''">
    <div class="d-flex align-items-center">

      <!-- Checkbox -->
      <label class="contraction-checkbox-wrap mb-0 mr-2" @click.stop>
        <input
          type="checkbox"
          class="contraction-checkbox"
          :checked="!!contraction.resolved_at || contraction.id === pendingResolveId"
          @change="onCheckboxChange()"
        />
        <span class="contraction-checkmark"></span>
      </label>

      <!-- Text + Date -->
      <div class="flex-grow-1 contraction-text-wrap">
        <div
          class="contraction-text"
          :class="{ 'contraction-text--processed': !!contraction.resolved_at }"
          v-text="contraction.contraction"
        ></div>
        <div class="contraction-date text-muted">{{ formatDate(contraction.created_at) }}</div>
      </div>

      <!-- Process button -->
      <router-link v-if="!contraction.resolved_at" :to="'/community?contraction_id=' + contraction.id" class="process-btn mr-2">
        <i class="fas fa-bolt mr-1"></i>Process
      </router-link>

      <!-- 3-dot menu -->
      <b-dropdown right no-caret variant="link" size="sm" class="contraction-menu p-0" @click.native.stop>
        <template #button-content>
          <i class="fas fa-ellipsis-v text-muted"></i>
        </template>
        <b-dropdown-item class="text-danger" @click="deleteContraction()">
          <i class="fas fa-trash-alt mr-1"></i> Delete
        </b-dropdown-item>
      </b-dropdown>

    </div>
  </b-list-group-item>
</template>

<script>
import axios from "@/axios";
export default {
  name: "HealingLogItem",
  props: {
    contraction: {
      type: Object,
      default: () => { return {}; }
    },
    priority: {
      type: String,
      default: null,
    },
    pendingResolveId: {
      default: null,
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric',
      });
    },

    onCheckboxChange() {
      if (!this.contraction.resolved_at) {
        this.$emit('request-resolve', this.contraction);
      } else {
        axios({
          method: 'post',
          url: `contractions/toggleResolve/${this.contraction.id}`,
        }).then(() => this.$emit('refreshFeelings'));
      }
    },

    deleteContraction() {
      axios({
        method: 'post',
        url: `${this.$store.state.api_url}contractions/delete/${this.contraction.id}`,
      }).then(() => this.$emit('refreshFeelings'));
    },
  },
};
</script>

<style>
.contraction-item {
  padding: 10px 14px !important;
}

.priority-recent {
  border-left: 2px solid #dc3545 !important;
  border-top: 1px solid #dee2e6 !important;
  border-top-width: 1px !important;
  margin-bottom: 10px !important;
  border-radius: 6px !important;
}

.list-group-item + .list-group-item.priority-recent {
  border-left: 2px solid #dc3545 !important;
  border-top: 1px solid #dee2e6 !important;
  border-top-width: 1px !important;
}

.priority-older {
  border-left: 2px solid #ffc107 !important;
  border-top: 1px solid #dee2e6 !important;
  border-top-width: 1px !important;
  margin-bottom: 10px !important;
  border-radius: 6px !important;
}

.list-group-item + .list-group-item.priority-older {
  border-left: 2px solid #ffc107 !important;
  border-top: 1px solid #dee2e6 !important;
  border-top-width: 1px !important;
}

.contraction-text-wrap { min-width: 0; }

.contraction-text {
  color: #333;
  overflow-wrap: break-word;
  word-break: break-word;
}

.contraction-text--processed { color: #aaa; }

.contraction-date {
  font-size: 0.7rem;
  margin-top: 3px;
  color: #bbb;
}

/* Checkbox */
.contraction-checkbox-wrap {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}

.contraction-checkbox-wrap input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.contraction-checkmark {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #d6b674;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s, border-color 0.18s;
  flex-shrink: 0;
}

.contraction-checkbox-wrap input:checked ~ .contraction-checkmark {
  background: #c4a55a;
  border-color: #c4a55a;
}

.contraction-checkmark::after {
  content: '';
  display: none;
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) translate(-1px, -1px);
}

.contraction-checkbox-wrap input:checked ~ .contraction-checkmark::after {
  display: block;
}

/* Process button */
.process-btn {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: #d6b674;
  border: 1px solid rgba(214,182,116,0.45);
  border-radius: 20px;
  padding: 3px 10px;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.18s, color 0.18s;
}

.process-btn:hover {
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  color: #fff;
  text-decoration: none;
  border-color: transparent;
}

/* 3-dot menu */
.contraction-menu ::v-deep .btn-link {
  padding: 0 6px;
  color: #aaa;
  line-height: 1;
}

.contraction-menu ::v-deep .btn-link:hover { color: #555; }

.contraction-menu ::v-deep .dropdown-item {
  color: #dc3545;
  font-size: 0.85rem;
}
</style>